import React, { useState, useEffect, useMemo } from 'react';
import { useEducationColony, useSelectCity } from '../hooks/DashboardHook';
import Select from 'react-select';

type Props = {
  filterDate: any;
  loadingGrid: boolean;
};

type SelectOptions = {
  value: number;
  label: string;
};

const GraficaColonia: React.FC<Props> = ({ filterDate, loadingGrid }) => {
  const [order, setOrder] = useState<'asc' | 'desc'>('desc');
  const [selectedDegree, setSelectedDegree] = useState<SelectOptions | null>({
    value: 965,
    label: 'Monterrey',
  });
  
  // Usar useMemo para estabilizar el objeto de filtros y evitar re-renders innecesarios
  const initValues = useMemo(() => ({
    order: order,
    cityId: selectedDegree?.value || 965,
    init_date: filterDate.init_date,
    end_date: filterDate.end_date,
  }), [order, selectedDegree?.value, filterDate.init_date, filterDate.end_date]);
  
  const { data: Colony } = useEducationColony(true, initValues);
  const { data: city } = useSelectCity(true);

  const handleDegree = (selectedOption: any) => {
    setSelectedDegree(selectedOption);
  };

  return (
    <div className="card card-flush w-100 h-475px ms-2">
      <div className="card-header pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label fw-bold text-dark fs-3">
            Usuarios por colonia
          </span>
          <span className="text-gray-400 mt-1 fw-semibold fs-6">
            Estudiantes registrados
          </span>
        </h3>
      </div>
      <div className="card-body pt-0">
        {loadingGrid ? (
          <div className="d-flex align-items-center">
            <div className="text-muted text-center fs-6 w-100 m-5">
              <span className="indicator-progress" style={{ display: 'block' }}>
                Espere por favor...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </div>
          </div>
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center w-100 mb-3 mt-3">
              <div>
                <Select
                  options={city}
                  placeholder={'Seleccione'}
                  onChange={handleDegree}
                  value={selectedDegree}
                  className="mb-3"
                  noOptionsMessage={() => {
                    return <span>No hay registros</span>;
                  }}
                  styles={{
                    placeholder: (provided, state) => ({
                      ...provided,
                      color: '#181c32',
                    }),
                    indicatorSeparator: (provided, state) => ({
                      ...provided,
                      display: 'none',
                    }),
                    dropdownIndicator: (provided, state) => ({
                      ...provided,
                      color: '#7E8199',
                    }),
                    control: (provided, state) => ({
                      ...provided,
                      border: '1px solid #e4e6ef',
                      borderRadius: '6px',
                      padding: '3px',
                      fontSize: '1.1rem',
                      boxShadow: 'none',
                      backgroundColor: state.isDisabled ? '#EFF2F5' : 'white',
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: '1.1rem',
                    }),
                  }}
                />
              </div>
              <div>
                <button
                  className="nav-link btn btn-sm btn-bg-secondary text-gray-500 px-4 me-1"
                  onClick={() =>
                    setOrder((prev) => (prev === 'asc' ? 'desc' : 'asc'))
                  }
                >
                  Ordenar {order === 'asc' ? '▲' : '▼'}
                </button>
              </div>
            </div>

            <div
              style={{
                maxHeight: '320px',
                overflowY: 'auto',
                marginTop: '1rem',
              }}
            >
              {Colony.length === 0 ? (
                <div className="text-muted text-center py-4">Sin registros</div>
              ) : (
                <>
                  <div className="d-flex fw-bold border-bottom px-3 py-2">
                    <div style={{ width: '10%' }}>#</div>
                    <div style={{ width: '50%' }}>Colonia</div>
                    <div style={{ width: '40%', textAlign: 'right' }}>
                      Usuarios
                    </div>
                  </div>

                  {Colony.map((row, idx) => {
                    const rowNumber =
                      order === 'asc' ? Colony.length - idx : idx + 1;

                    return (
                      <div
                        key={row.id}
                        className="d-flex align-items-center px-3 py-2"
                      >
                        <div style={{ width: '10%' }}>{rowNumber}</div>
                        <div
                          style={{
                            width: '50%',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {row.name}
                        </div>
                        <div style={{ width: '40%', textAlign: 'right' }}>
                          {row.total_students}
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export { GraficaColonia };
